import React, { useCallback, useState } from 'react'
import Grid from '@mui/material/Grid'
import { Box } from '../box'
import { destinations } from '../../constants/destinoPrestamo/index'
import { useDispatch } from 'react-redux'
import { setDestinationState } from 'context/reducer/quota'

import {
  AttachMoney,
  BusinessCenterOutlined,
  HomeWorkOutlined,
  DirectionsCarOutlined,
  BeenhereOutlined,
  AirplanemodeActiveOutlined,
} from '@mui/icons-material'

export const Destination: React.FC<{isMobile: boolean}> = ({isMobile}) => {
  const [options, setOptions] = useState(destinations)
  const dispatch = useDispatch()

  const icons = [
    <AttachMoney />,
    <HomeWorkOutlined />,
    <DirectionsCarOutlined />,
    <BusinessCenterOutlined />,
    <AirplanemodeActiveOutlined/>,
    <BeenhereOutlined />,
  ]

  const handleSelected = useCallback(
    (item) => () => {
      options[item.id].selected = !item.selected
      setOptions([...options])
      const finded = options.filter((option) => option.selected).map((option) => option.code)
      dispatch(setDestinationState(finded))
    },
    [options, setOptions, dispatch]
  )

  return (
    <div className='bp-mt-32'>
      <pichincha-typography
        variant="bodyText"
        color="darkGrey"
        weight_color="700"
      >
        ¿Qué destino tendrá el préstamo?
      </pichincha-typography>
      <Grid
        container
        direction="row"
        justifyContent='flex-start'    
        spacing={2}
        className="bp-mt-4"
      >
        {options.map((item: any, index) => (
          <Grid item key={item.id}>
            <Box
              square={isMobile}
              title={item.title}
              isMobile={isMobile}
              subtitle={item.subtitle}
              icon={icons[index]}
              selected={item.selected}
              handleOnClick={handleSelected({ ...item })}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
